<div class="payment-type">
    <div>Payment type:</div>
    <div class="checkboxes">
        <!-- <div class="box" *ngFor="let paymentType of paymentTypesInternal">
            <p-checkbox [(ngModel)]="internalSelectedPayment" [value]="paymentType.value" [label]="paymentType.title"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectionChange($event)"></p-checkbox>
            <p-floatLabel *ngIf="internalSelectedPayment.includes(paymentType.value)">
                <p-inputNumber [(ngModel)]="paymentType.total" inputId="currency-us" mode="currency" currency="USD"
                    locale="en-US" (ngModelChange)="onTotalChange(paymentType.id, $event)" />
                <label for="number-input">{{paymentType.title}} total</label>
            </p-floatLabel>
            <p-floatLabel *ngIf="paymentType.value == 2 && internalSelectedPayment.includes(paymentType.value)">
                <input type="checkNumber" pInputText [(ngModel)]="checkNumber"
                    (ngModelChange)="onCheckNumberChange($event)" />
                <label for="checkNumber">Check number (optional)</label>
            </p-floatLabel>
        </div> -->

        <div class="box">
            <p-checkbox [(ngModel)]="selectedPaymentTypes" [value]="1" label="Cash"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectionChange($event)"></p-checkbox>
            <p-floatLabel *ngIf="selectedPaymentTypes.includes(1)">
                <p-inputNumber [(ngModel)]="poManager.current.totalCash" inputId="currency-us" mode="currency"
                    [currency]="userCurrency" locale="en-US" [min]="0" [max]="allowedCashAmount"/>
                <label for="number-input">Cash total</label>
            </p-floatLabel>
        </div>
        <div class="box">
            <p-checkbox [(ngModel)]="selectedPaymentTypes" [value]="2" label="Check"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectionChange($event)"></p-checkbox>
            <p-floatLabel *ngIf="selectedPaymentTypes.includes(2)">
                <p-inputNumber [(ngModel)]="poManager.current.totalCheck" inputId="currency-us" mode="currency"
                    [currency]="userCurrency" locale="en-US" [min]="0"/>
                <label for="number-input">Check total</label>
            </p-floatLabel>
            <p-floatLabel *ngIf="selectedPaymentTypes.includes(2)">
                <input type="checkNumber" pInputText [(ngModel)]="poManager.current.checkNumber"/>
                <label for="checkNumber">Check number (optional)</label>
            </p-floatLabel>
        </div>
        <div class="box">
            <p-checkbox [(ngModel)]="selectedPaymentTypes" [value]="4" label="Wire Transfer"
                [ngModelOptions]="{standalone: true}" (ngModelChange)="onSelectionChange($event)"></p-checkbox>
            <p-floatLabel *ngIf="selectedPaymentTypes.includes(4)">
                <p-inputNumber [(ngModel)]="poManager.current.totalWire" inputId="currency-us" mode="currency"
                    [currency]="userCurrency" locale="en-US" [min]="0" />
                <label for="number-input">Wire Transfer total</label>
            </p-floatLabel>
        </div>
    </div>
</div>